import { TCardCamp } from '@/types/camp/CardCamp';
import { useState } from 'react';
import { useRequest } from '@@/plugin-request/request';
import { requestGet } from '@/utils/request';
import { message } from 'antd';

export default function useCardCampModel() {
  const [cardCamp, setCardCamp] = useState<TCardCamp>();

  const { run: getCardCamp } = useRequest(
    (campId: string) => {
      return requestGet(`/api/camp/card/camp/${campId}`, {});
    },
    {
      manual: true,
      onSuccess: (res) => {
        setCardCamp(res.data);
      },
      onError: (err) => {
        message.error(err.message);
      },
    },
  );

  return {
    cardCamp,
    getCardCampRun: getCardCamp,
  };
}
